import React, { Component } from 'react';
import { multiLanguage } from "../../hoc";
import data from '../../data/SanctuaryClub/about'

const logoImg = 'https://lagunaproperty.com/images/sanc-logo.png';

@multiLanguage()
export default class About extends Component {
  render() {
    const { t } = this.props;
    const { content } = data;
    return (
      <div className="section2-about">
        <div className="section2-content">
          <img className="section2-logo" src={logoImg} alt="logo" />
          <div className="section2-text">
            <h2>{t("About The club")}</h2>
            <div dangerouslySetInnerHTML={{ __html: t(content.description) }} />
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/SanctuaryClub/About.js